import { TyloAssortmentServiceService } from './services/tylo-assortment-service.service';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TyloAppComponent } from './tylo-app.component';
import {
  GungStandardModule,
  createTranslateLocalLoader,
  TranslationLocalService,
  BackendInterceptor,
  ProductListConfigService,
  NavbarConfigService,
  ProductService,
  CheckoutConfigService,
  FavouriteProductsService,
  SalesCartConfigService,
  OrderListConfigService,
  CartConfigService,
  AvailabilityHelperService,
  AssortmentService,
  PriceConfigService,
  LanguageConfigService,
  OrderToBasketService,
  NewsActionConfigService,
  ProductListByIdsConfigService,
  ProductExportActionConfigService,
  MetadataService,
  CartExportService,
  ProductInlineSearchListConfigService,
  InvoiceListConfigService,
  DigitalAssetsService,
  GungModalService,
  OpenOrdersConfigService,
  SavedQuoteConfigService,
  ProductInputQuantityConfigService,
  ProductExportListConfigService,
  PriceService,
  CustomerDetailsConfigService,
  ReturnWarrantyListConfigService,
  OrderServicesService,
  DeliveryDateService
} from 'gung-standard';
import { FilterListService, GungListModule } from 'gung-list';
import {
  GungStandardJeevesModule,
  JeevesCustomerDeliveryLocationListConfigService,
  JeevesCustomerDetailsConfigService,
  JeevesInvoiceListConfigService,
  JeevesOpenOrdersConfigService,
  JeevesDeliveryDateService,
  JeevesOrderActionConfigService
} from 'gung-standard-jeeves';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TyloBackendInterceptorService } from './services/tylo-backend-interceptor.service';
import { GungDashboardModule } from 'gung-dashboard';
import { TyloNavbarConfigService } from './services/tylo-navbar-config.service';
import { TyloProductDetailComponent } from './components/tylo-product-detail/tylo-product-detail.component';
import { TyloTranslationLocalService } from './services/tylo-translation-local.service';
import { TyloProductService } from './services/tylo-product.service';
import { TyloProductListConfigService } from './services/tylo-product-list-config.service';
import { TyloDeliveryLocationsJeevesComponent } from './components/checkout/sweden/tylo-delivery-locations-jeeves/tylo-delivery-locations-jeeves.component';
import { TyloCheckoutConfigService } from './services/tylo-checkout-config.service';
import { TyloOrderTermsJeevesComponent } from './components/checkout/sweden/tylo-order-terms-jeeves/tylo-order-terms-jeeves.component';
import { TyloSummarizeOrderJeevesComponent } from './components/checkout/sweden/tylo-summarize-order-jeeves/tylo-summarize-order-jeeves.component';
import { TyloFavouriteProductsService } from './services/tylo-favourite-products.service';
import { TyloJeevesSalesCartListComponent } from './components/checkout/sweden/tylo-jeeves-sales-cart-list/tylo-jeeves-sales-cart-list.component';
import { TyloJeevesSalesCartConfigService } from './services/tylo-jeeves-sales-cart-config.service';
import { TyloProductListComponent } from './components/tylo-product-list/tylo-product-list.component';
import { TyloJeevesOrderCardListComponent } from './components/tylo-jeeves-order-card-list/tylo-jeeves-order-card-list.component';
import { TyloJeevesOrderListConfigService } from './services/tylo-jeeves-order-list-config.service';
import { TyloCartListComponent } from './components/checkout/sweden/tylo-cart-list/tylo-cart-list.component';
import { TyloCartConfigService } from './services/tylo-cart-config.service';
import { TyloAssignJeevesDefaultsComponent } from './components/checkout/sweden/tylo-assign-jeeves-defaults/tylo-assign-jeeves-defaults.component';
import { TyloHomeAssortmentComponent } from './components/tylo-home-assortment/tylo-home-assortment.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { TyloAvailabilityHelperService } from './services/tylo-availability-helper.service';
import { TyloMetadataService } from './services/tylo-metadata.service';
import { TyloDeliveryPlanningComponent } from './components/tylo-delivery-planning/tylo-delivery-planning.component';
import { TyloDeliveryPlanningCardListComponent } from './components/tylo-delivery-planning-card-list/tylo-delivery-planning-card-list.component';
import { TyloAppWrapperComponent } from './components/tylo-app-wrapper/tylo-app-wrapper.component';
import { TyloDocumentsListComponent } from './components/tylo-documents-list/tylo-documents-list.component';
import { TyloPreliminaryDeliveryTimeWarningComponent } from './components/checkout/sweden/tylo-preliminary-delivery-time-warning/tylo-preliminary-delivery-time-warning.component';
import { TyloPriceConfigService } from './services/tylo-price-config.service';
import { TyloLanguageConfigService } from './services/tylo-language-config.service';
import { environment } from './../environments/environment';
import { TyloNavbarComponent } from './components/tylo-navbar/tylo-navbar.component';
import { TyloFashionLoginComponent } from './components/tylo-fashion-login/tylo-fashion-login.component';
import { TyloLoginWrapperComponent } from './components/tylo-login-wrapper/tylo-login-wrapper.component';
import { TyloOrderToBasketService } from './services/tylo-order-to-basket.service';
import { TyloNewsActionService } from './services/tylo-news-action.service';
import { TyloProductGridViewComponent } from './components/tylo-product-grid-view/tylo-product-grid-view.component';
import { TyloProductTableComponent } from './components/tylo-product-table/tylo-product-table.component';
import { TyloDocumentsUploadModalComponent } from './components/documents-upload/tylo-documents-upload-modal/tylo-documents-upload-modal.component';
import { TyloDocumentsComponent } from './components/documents-upload/tylo-documents/tylo-documents.component';
import { TyloHomeComponent } from './components/tylo-home/tylo-home.component';
import { HeloAssignJeevesDefaultsComponent } from './components/checkout/finland/helo-assign-jeeves-defaults/helo-assign-jeeves-defaults.component';
import { HeloCartListComponent } from './components/checkout/finland/helo-cart-list/helo-cart-list.component';
import { HeloDeliveryLocationsComponent } from './components/checkout/finland/helo-delivery-locations/helo-delivery-locations.component';
import { HeloJeevesSalesCartListComponent } from './components/checkout/finland/helo-jeeves-sales-cart-list/helo-jeeves-sales-cart-list.component';
import { HeloOrderTermsJeevesComponent } from './components/checkout/finland/helo-order-terms-jeeves/helo-order-terms-jeeves.component';
import { HeloPreliminaryDeliveryTimeWarningComponent } from './components/checkout/finland/helo-preliminary-delivery-time-warning/helo-preliminary-delivery-time-warning.component';
import { HeloShipFromSwedenInfoComponent } from './components/checkout/finland/helo-ship-from-sweden-info/helo-ship-from-sweden-info.component';
import { HeloSummarizeOrderJeevesComponent } from './components/checkout/finland/helo-summarize-order-jeeves/helo-summarize-order-jeeves.component';
import { HeloCartTotalStepComponent } from './components/checkout/finland/helo-cart-total-step/helo-cart-total-step.component';
import { HeloCartSalesStepComponent } from './components/checkout/finland/helo-cart-sales-step/helo-cart-sales-step.component';
import { TyloFilterListService } from './services/tylo-filter-list.service';
import { TyloCustomerDeliveryLocationCartListComponent } from './components/checkout/sweden/tylo-customer-delivery-location-cart-list/tylo-customer-delivery-location-cart-list.component';
import { TyloCustomerDeliveryLocationListConfigService } from './services/tylo-customer-delivery-location-list-config.service';
import { TyloOrderTermsWithCartListJeevesComponent } from './components/checkout/sweden/tylo-order-terms-with-cart-list-jeeves/tylo-order-terms-with-cart-list-jeeves.component';
import { HeloWarrantyFormComponent } from './components/helo-warranty-form/helo-warranty-form.component';
import { TyloDeliveryPlanningEditModalComponent } from './components/tylo-delivery-planning-edit-modal/tylo-delivery-planning-edit-modal.component';
import { TyloProductListByIdsConfigService } from './services/tylo-product-list-by-ids-config.service';
import { TyloOrderDetailsComponent } from './components/tylo-order-details/tylo-order-details.component';
import { TyloProductExportActionConfigService } from './services/tylo-product-export-action-config.service';
import { GungCommonModule } from 'gung-common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TyloButtonsComponent } from './components/checkout/tylo-buttons/tylo-buttons.component';
import { TyloCartExportService } from './services/tylo-cart-export.service';
import { TyloInlineSearchCardComponent } from './components/tylo-inline-search-card/tylo-inline-search-card.component';
import { TyloNavbarInlineSearchComponent } from './components/tylo-navbar-inline-search/tylo-navbar-inline-search.component';
import { TyloInlineSearchListConfigService } from './services/tylo-inline-search-list-config.service';
import { TyloJeevesInvoiceListConfigService } from './services/tylo-jeeves-invoice-list-config.service';
import { TyloJeevesInvoiceCardListComponent } from './components/tylo-jeeves-invoice-card-list/tylo-jeeves-invoice-card-list.component';
import { TyloDigitalAssetsManagementItemComponent } from './components/digital-assets/tylo-digital-assets-management-item/tylo-digital-assets-management-item.component';
import { TyloDigitalAssetsWrapperComponent } from './components/digital-assets/tylo-digital-assets-wrapper/tylo-digital-assets-wrapper.component';
import { TyloDigitalAssetsService } from './services/tylo-digital-assets.service';
import { TyloDigitalAssetsModalComponent } from './components/digital-assets/tylo-digital-assets-modal/tylo-digital-assets-modal.component';
import { TyloModalService } from './services/tylo-modal.service';
import { HeloSaunaVolumeCalculatorComponent } from './components/helo-sauna-volume-calculator/helo-sauna-volume-calculator.component';
import { HeloSavedQuoteTableComponent } from './components/helo-saved-quote-table/helo-saved-quote-table.component';
import { TyloSavedQuoteConfigService } from './services/tylo-saved-quote-config.service';
import { TyloProductInputQuantityConfigService } from './services/tylo-product-input-quantity-config.service';
import { TyloProductExportListConfigService } from './services/tylo-product-export-list-config.service';
import { TyloPriceService } from './services/tylo-price.service';
import { TyloCustomerB2cPriceMarkupModalComponent } from './components/tylo-customer-b2c-price-markup-modal/tylo-customer-b2c-price-markup-modal.component';
import { TyloExportQuotationModalComponent } from './components/tylo-export-quotation-modal/tylo-export-quotation-modal.component';
import { TyloCustomerDetailsConfigService } from './services/tylo-customer-details-config.service';
import { TyloReturnWarrantyListConfigService } from './services/tylo-return-warranty-list-config.service';
import { TyloReturnWarrantyCreateViewModalComponent } from './components/tylo-return-warranty-create-view-modal/tylo-return-warranty-create-view-modal.component';
import { TyloReturnWarrantyTableComponent } from './components/tylo-return-warranty-table/tylo-return-warranty-table.component';
import { TyloReturnWarrantyComponent } from './components/tylo-return-warranty/tylo-return-warranty.component';
import { TyloOrderServicesService } from './services/tylo-order-services.service';
import { TyloDeliveryDateService } from './services/tylo-delivery-date.service';
import { TyloJeevesOrderActionConfigService } from './services/tylo-jeeves-order-action-config.service';

@NgModule({
  declarations: [
    TyloAppComponent,
    TyloProductDetailComponent,
    TyloDeliveryLocationsJeevesComponent,
    TyloOrderTermsJeevesComponent,
    TyloSummarizeOrderJeevesComponent,
    TyloJeevesSalesCartListComponent,
    TyloProductListComponent,
    TyloJeevesOrderCardListComponent,
    TyloCartListComponent,
    TyloAssignJeevesDefaultsComponent,
    TyloHomeAssortmentComponent,
    TyloDeliveryPlanningComponent,
    TyloDeliveryPlanningCardListComponent,
    TyloAppWrapperComponent,
    TyloDocumentsListComponent,
    TyloPreliminaryDeliveryTimeWarningComponent,
    TyloNavbarComponent,
    TyloFashionLoginComponent,
    TyloLoginWrapperComponent,
    TyloProductGridViewComponent,
    TyloProductTableComponent,
    TyloDocumentsUploadModalComponent,
    TyloDocumentsComponent,
    TyloHomeComponent,
    HeloAssignJeevesDefaultsComponent,
    HeloCartListComponent,
    HeloDeliveryLocationsComponent,
    HeloJeevesSalesCartListComponent,
    HeloOrderTermsJeevesComponent,
    HeloPreliminaryDeliveryTimeWarningComponent,
    HeloShipFromSwedenInfoComponent,
    HeloSummarizeOrderJeevesComponent,
    HeloCartTotalStepComponent,
    HeloCartSalesStepComponent,
    TyloCustomerDeliveryLocationCartListComponent,
    TyloOrderTermsWithCartListJeevesComponent,
    HeloWarrantyFormComponent,
    TyloDeliveryPlanningEditModalComponent,
    TyloOrderDetailsComponent,
    TyloButtonsComponent,
    TyloInlineSearchCardComponent,
    TyloNavbarInlineSearchComponent,
    TyloJeevesInvoiceCardListComponent,
    TyloDigitalAssetsManagementItemComponent,
    TyloDigitalAssetsWrapperComponent,
    TyloDigitalAssetsModalComponent,
    HeloSaunaVolumeCalculatorComponent,
    HeloSavedQuoteTableComponent,
    TyloCustomerB2cPriceMarkupModalComponent,
    TyloExportQuotationModalComponent,
    TyloReturnWarrantyTableComponent,
    TyloReturnWarrantyCreateViewModalComponent,
    TyloReturnWarrantyComponent
  ],
  bootstrap: [TyloAppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    GungStandardModule,
    GungStandardJeevesModule,
    GungDashboardModule,
    GungCommonModule,
    GungListModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxImageZoomModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLocalLoader,
        deps: [TranslationLocalService]
      }
    })
  ],
  providers: [
    { provide: 'environment', useValue: environment },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TyloBackendInterceptorService,
      multi: true
    },
    {
      provide: MetadataService,
      useClass: TyloMetadataService
    },
    {
      provide: BackendInterceptor,
      useClass: TyloBackendInterceptorService
    },
    {
      provide: TranslationLocalService,
      useClass: TyloTranslationLocalService
    },
    {
      provide: NavbarConfigService,
      useClass: TyloNavbarConfigService
    },
    {
      provide: ProductService,
      useClass: TyloProductService
    },
    {
      provide: ProductListConfigService,
      useClass: TyloProductListConfigService
    },
    {
      provide: CheckoutConfigService,
      useClass: TyloCheckoutConfigService
    },
    {
      provide: FavouriteProductsService,
      useClass: TyloFavouriteProductsService
    },
    {
      provide: SalesCartConfigService,
      useClass: TyloJeevesSalesCartConfigService
    },
    {
      provide: OrderListConfigService,
      useClass: TyloJeevesOrderListConfigService
    },
    {
      provide: CartConfigService,
      useClass: TyloCartConfigService
    },
    {
      provide: AvailabilityHelperService,
      useClass: TyloAvailabilityHelperService
    },
    {
      provide: AssortmentService,
      useClass: TyloAssortmentServiceService
    },
    {
      provide: PriceConfigService,
      useClass: TyloPriceConfigService
    },
    {
      provide: LanguageConfigService,
      useClass: TyloLanguageConfigService
    },
    {
      provide: OrderToBasketService,
      useClass: TyloOrderToBasketService
    },
    {
      provide: NewsActionConfigService,
      useClass: TyloNewsActionService
    },
    {
      provide: FilterListService,
      useClass: TyloFilterListService
    },
    {
      provide: JeevesCustomerDeliveryLocationListConfigService,
      useClass: TyloCustomerDeliveryLocationListConfigService
    },
    {
      provide: ProductListByIdsConfigService,
      useClass: TyloProductListByIdsConfigService
    },
    {
      provide: ProductExportActionConfigService,
      useClass: TyloProductExportActionConfigService
    },
    {
      provide: CartExportService,
      useClass: TyloCartExportService
    },
    {
      provide: ProductInlineSearchListConfigService,
      useClass: TyloInlineSearchListConfigService
    },
    {
      provide: JeevesInvoiceListConfigService,
      useClass: TyloJeevesInvoiceListConfigService
    },
    {
      provide: DigitalAssetsService,
      useClass: TyloDigitalAssetsService
    },
    {
      provide: GungModalService,
      useClass: TyloModalService
    },
    {
      provide: OpenOrdersConfigService,
      useClass: JeevesOpenOrdersConfigService
    },
    {
      provide: SavedQuoteConfigService,
      useClass: TyloSavedQuoteConfigService
    },
    {
      provide: ProductInputQuantityConfigService,
      useClass: TyloProductInputQuantityConfigService
    },
    {
      provide: ProductExportListConfigService,
      useClass: TyloProductExportListConfigService
    },
    {
      provide: PriceService,
      useClass: TyloPriceService
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: CustomerDetailsConfigService,
      useClass: TyloCustomerDetailsConfigService
    },
    {
      provide: JeevesCustomerDetailsConfigService,
      useClass: TyloCustomerDetailsConfigService
    },
    {
      provide: ReturnWarrantyListConfigService,
      useClass: TyloReturnWarrantyListConfigService
    },
    {
      provide: OrderServicesService,
      useClass: TyloOrderServicesService
    },
    {
      provide: DeliveryDateService,
      useClass: TyloDeliveryDateService
    },
    {
      provide: JeevesDeliveryDateService,
      useClass: TyloDeliveryDateService
    },
    {
      provide: JeevesOrderActionConfigService,
      useClass: TyloJeevesOrderActionConfigService
    }
  ]
})
export class TyloAppModule {
  constructor(
    translate: TranslateService,
    private titleService: Title
  ) {
    this.titleService.setTitle(this.getPageTitle());
    const defaultLang = environment.projectName === 'tylo' ? 'se' : 'fi';
    translate.setDefaultLang(defaultLang);
  }

  private getPageTitle(): string {
    if (!!environment.siteTitle) {
      return environment.siteTitle;
    } else {
      return environment.projectName.charAt(0).toUpperCase() + environment.projectName.slice(1);
    }
  }
}
